import { Component, OnInit, Input, ViewChild, Output, OnChanges, ChangeDetectionStrategy } from '@angular/core';
import { SelectionModel } from '@angular/cdk/collections';
import {MatMenuTrigger} from '@angular/material/menu';
import { MatSort } from '@angular/material/sort'
import { MatTableDataSource } from '@angular/material/table';
import { typeDHLFormControls } from '../../models/dhl-form-shared-types';
import { UntypedFormGroup } from '@angular/forms';
import { EventEmitter } from 'events';
import { AppService } from 'src/app/app.service';
import { DhlFormControlEvent } from '../../models/dhl-form-control-event';
import { DhlFormControlEventData } from '../../models/dhl-form-control-event-data';
 
@Component({
    selector: 'app-form-table',
    templateUrl: './form-table.component.html',
    styleUrls: ['./form-table.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FormTableComponent implements OnInit, OnChanges {
  @Input() configData: typeDHLFormControls;
  @Input() frmGroup: UntypedFormGroup;
  @Input() searchData;
  @Input() searchMessage;
  @Output() clearFilter = new EventEmitter();
  @Output() errorMessage = new EventEmitter();
  @ViewChild(MatMenuTrigger, {static: true, read: MatMenuTrigger}) trigger: MatMenuTrigger;
  xPosition;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  tabelConfig;
  color: String = 'primary';
  mode: String = 'indeterminate';
  isLoading: boolean = false;
  serverError: string= '';

  constructor(private appService: AppService) { }

  dataSource: MatTableDataSource<NewOrder>;  // change the neworder to generic
  selection = new SelectionModel<NewOrder>(true, []);  // change the neworder to generic
  newDisplayedColumns = [];

  ngOnChanges() {
    if (this.tabelConfig && this.tabelConfig.TableHeaders) {
      this.tabelConfig.TableHeaders.forEach(element => {
        this.newDisplayedColumns.push(element.title);
      });
    }
  }

  ngOnInit() {
    // this.tabelConfig = this.appService.getSearchResultMetaData();
    let note = document.getElementById('table-orders');
    let screenPosition = note.getBoundingClientRect();
    this.xPosition = screenPosition['x'];

    // if (this.tabelConfig && this.tabelConfig.TableHeaders) {
    //   this.tabelConfig.TableHeaders.forEach(element => {
    //     this.newDisplayedColumns.push(element.title);
    //   });
    // }
    let event: DhlFormControlEvent | null = this.checkEventExist(this.configData.events, 'init');
    if (event) {
    //   this.sendToSource(event);
    // }
    // if (this.configData.events && Array.isArray(this.configData.events)) {
      let event = this.configData.events.filter(ele => ele.event == 'init');
      if (event && event.length) {
        this.appService._commonComponentSubject.next({
          component: this,
          configData: this.configData,
          event: event[0].event,
          eventData: event[0],
          action: event[0].action,
          name: this.configData.name
        })
        return
      }
    }
  }

  /** Method to handle events from component.html */
  checkScroll() {
    let headerFixedHolder = document.getElementById('table-orders');
    let left = headerFixedHolder.scrollLeft;
    let myElements = document.querySelectorAll(".action-icons");

    for (let i = 0; i < myElements.length; i++) {
      if (left == 0) {
        myElements[i]['style'].right = 0
      } else {
        myElements[i]['style'].right = '-' + left.toString() + 'px';
      }
    }
  }

  /** Whether the number of selected elements matches the total number of rows. */
  isAllSelected() {
    const numSelected = this.selection.selected.length;
    let numRows = 0;
    if (this.dataSource && this.dataSource.data) {
      numRows = this.dataSource.data.length || 0;
    }
    return numSelected === numRows;
  }

  isRowSelected(row) {
    let selected = this.selection.isSelected(row) ||  row.favourite ;
    if(selected){
      this.selection.select(row);
      return this.selection.isSelected(row);
    }
    return false;
  }
  
  toggleSearchPreference(e, row, rowOptions){
    e.stopPropagation();
    this.selection.toggle(row);
    row.favourite = this.selection.isSelected(row);
    let event: DhlFormControlEvent | null = this.checkEventExist(rowOptions.events, 'ROW_SELECT');
    if (event) {
      this.sendToSource(event, row);
    }
  }
  
  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    this.isAllSelected() ?
      this.selection.clear() :
      this.dataSource.data.forEach(row => this.selection.select(row));
  }

  /** The label for the checkbox on the passed row */
  checkboxLabel(row?: NewOrder): string {
    if (!row) {
      return `${this.isAllSelected() ? 'select' : 'deselect'} all`;
    }
    // return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${row.position + 1}`;
  }

  /** Common Method to check event exist in template */
  checkEventExist(events, eventName): DhlFormControlEvent | null {
    let event = null;
    if (events && Array.isArray(events)) {
      event = events.filter(ele => ele.event == eventName);
      event = (event.length ? event[0] : null);
    }
    return event;
  }

  sendToSource(event: DhlFormControlEvent, row = {} ) {
    let eventData: DhlFormControlEventData = {
      event: event.event,
      eventData: event,
      action: event.action,
      name: this.configData.name,
      component: this,
      configData: this.configData,
      data: row,
    }
    this.appService._commonComponentSubject.next(eventData);
  }

  /** Row click can be handled here */
  onRowClickHandler(row, rowOptions) {
    let event: DhlFormControlEvent | null = this.checkEventExist(rowOptions.events, 'ROW_CLICK');
    if (event) {
      this.sendToSource(event, row);
    }
  }

  performAction(e, name, orderData, config, action) {

  }
  addSortingFeature() {
    this.dataSource.sort = this.sort;
    let columnToBeSort;
    this.dataSource.sortingDataAccessor = (item, property) => {
      switch (property) {
        default: {
          this.tabelConfig.TableHeaders.some(column => {
            if (property === column.title) {
              if (column.sortColumnAttribute instanceof Object)
                columnToBeSort = column.sortColumnAttribute.key;
              else
                columnToBeSort = column.sortColumnAttribute;
              return true;
            } else {
              columnToBeSort = null;
              return false;
            }
          });
          return item[columnToBeSort];
        }
      }
    }
  }
}

export interface NewOrder {
  DEST_LOCATION_POSTAL_CODE: string;
  SOURCE_LOCATION_COUNTRY_CODE: string;
  TOTAL_VOLUME: string;
  REFNUM_QUAL_XID: string;
  DEST_LOCATION_COUNTRY_CODE: string;
  ORDER_TYPE_XID: string;
  ORDER_RELEASE_GID: string;
  SOURCE_LOCATION_PROVINCE_CODE: string;
  SOURCE_LOCATION_ADDRESS_LINE: string;
  REFNUM_VALUE: string;
  DEST_LOCATION_ADDRESS_LINE: string;
  EARLY_PICKUP_DATE: string;
  TOTAL_VOLUME_UOM_CODE: string;
  DEST_LOCATION_XID: string;
  DEST_LOCATION_CITY: string;
  SOURCE_LOCATION_NAME: string;
  ITEM_QUANTITY: string;
  SOURCE_LOCATION_XID: string;
  DEST_LOCATION_PROVINCE_CODE: string;
  LATE_DELIVERY_DATE: string;
  DOMAIN_NAME: string;
  DEST_LOCATION_NAME: string;
  SOURCE_LOCATION_CITY: string;
  TOTAL_WEIGHT: string;
  TOTAL_WEIGHT_UOM_CODE: string;
  STATUS_VALUE_XID: string;
  SOURCE_LOCATION_POSTAL_CODE: string;
  ORDER_RELEASE_XID: string;
  INSERT_DATE: string;
  WeightVolumePrimaryText: string;
  WeightVolumeSecondaryText: string;
  InsertdatePrimaryText: string;
  OrderPrimaryText: string;
  OrderSecondaryText: string;
  CustomerPrimaryText: string;
  StatusPrimaryText: string;
  TypePrimaryText: string;
  PickupLocationPrimaryText: string;
  PickupLocationSecondaryText: string;
  PickupDatePrimaryText: string;
  DeliveryLocationPrimaryText: string;
  DeliveryLocationSecondaryText: string;
  DeliveryDatePrimaryText: string;
  actions: string;
}
